function authPlugin({ opContext }) {
  opContext.headers["X-Shopify-Storefront-Access-Token"] =
    window.themeVariables.environment.variables.shopify_storefront_token;
}

export default authPlugin;
